<div class="field" [class.disabled]="disabled">
  <label class="is-size-6 is-unselectable">{{ label }}</label>&nbsp;
  <input
    id="{{'switch' + id}}"
    class="switch is-rounded is-link"
    type="checkbox"
    [name]="'mode'"
    [(ngModel)]="value"
    (change)="changeValue.emit(value)"/>
  <label for="{{'switch' + id}}" ></label>
</div>
